import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { capturePageview } from './telemetry';

export function PageviewTracker() {
  const location = useLocation();
  const last = useRef<string | null>(null);

  useEffect(() => {
    const key = `${location.pathname}${location.search}`;
    if (last.current === key) return;
    last.current = key;
    capturePageview(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return <Outlet />;
}
